export type IDomainOutletState = "open" | "closed" | "pre_order_only" | "busy";

export const OUTLET_STATES = {
  OPEN: "open" as const,
  CLOSED: "closed" as const,
  PRE_ORDER_ONLY: "pre_order_only" as const,
  BUSY: "busy" as const,
};
